(() => {
  if (customElements.get('size-fit-guide-04')) return;
  function parseCSV(raw, sourceUnit) {
    const sets = {}; let unit = sourceUnit, row = [], cell = '', quoted = false;
    const rows = [];
    for (let i = 0; i <= raw.length; i++) {
      const c = raw[i] ?? '\n';
      if (c === '"') { if (quoted && raw[i + 1] === '"') { cell += '"'; i++; } else quoted = !quoted; }
      else if (!quoted && (c === ',' || c === '\n')) { row.push(cell.trim()); cell = ''; if (c === '\n') { if (row.some(Boolean)) rows.push(row); row = []; } }
      else if (c !== '\r') cell += c;
    }
    rows.forEach(r => { if (/^\[(CM|IN)\]$/i.test(r[0])) unit = r[0].slice(1, -1).toLowerCase(); else (sets[unit] ||= []).push(r); });
    return sets;
  }
  class SizeFitGuide extends HTMLElement {
    // ERD desktop repositions the real Shopify accordion column using
    // Element.moveBefore(). Without connectedMoveCallback the browser fires
    // disconnectedCallback during that state-preserving move, which removes
    // the Size & Fit dialog from <body> and aborts its click handlers.
    // Keep the original dialog, [+] buttons and article references alive.
    connectedMoveCallback() {
      // Intentionally preserve the connected state and current open panel.
    }
    connectedCallback() {
      if (this.dialog) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      this.unit = this.dataset.unit === 'cm' ? 'cm' : 'in';
      this.sets = parseCSV(this.querySelector('[data-guide-csv]').value, this.unit);
      this.decimals = Math.max(0, Math.min(3, Number(this.dataset.decimals) || 0));
      document.body.append(this.dialog);
      this.controller = new AbortController(); const options = { signal: this.controller.signal };
      this.querySelector('[data-guide-open]').addEventListener('click', e => this.openGuide(e.currentTarget), options);
      this.summary = this.closest('details')?.querySelector('summary');
      this.dialog.querySelector('[data-guide-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('click', e => { if (e.target === this.dialog) this.dialog.close(); }, options);
      this.dialog.addEventListener('close', () => { if (!this.dialog.open) this.unlock(); }, options);
      this.dialog.querySelector('[data-guide-support]')?.addEventListener('click', () => {
        const chat = document.querySelector('shopify-chat');
        const launcher = chat?.shadowRoot?.querySelector('button[part="activator"]');
        if (!launcher) {
          (this.guideContent || this.dialog).querySelector('[data-support-status]').hidden = false;
          return;
        }
        if (this.dialog.open) {
          this.dialog.addEventListener('close', () => launcher.click(), { once: true });
          this.dialog.close();
        } else launcher.click();
      }, options);
      this.dialog.querySelectorAll('[data-unit]').forEach(b => b.addEventListener('click', () => { this.unit = b.dataset.unit; this.renderTable(); }, options));
      this.resize = new ResizeObserver(() => this.paintMoss()); this.resize.observe(this.dialog.querySelector('.sg04-moss'));
      window.addEventListener('load', () => this.paintMoss(), options);
      this.renderTable();
      this.panelHeading = (title) => {
        const key = String(title || '').trim().toLowerCase();
        if (key === 'details') return 'Product Details';
        if (key === 'materials') return 'Materials';
        if (key === 'size & fit' || key === 'size and fit') return 'Size & Fit';
        if (key === 'try on') return 'Try On';
        if (key === 'shipping & returns' || key === 'shipping and returns') return 'Shipping, Exchanges and Returns';
        return title || 'Product Details';
      };
      this.guideTitle = 'Size & Fit';
      this.dialog.querySelector('h2').textContent = this.guideTitle;
      this.guideCloseLabel = this.dialog.querySelector('[data-guide-close]').getAttribute('aria-label');
      this.guideContent = document.createElement('div');
      this.guideContent.className = 'sg04-guide-content';
      const scroll = this.dialog.querySelector('.sg04-scroll');
      this.guideContent.append(...scroll.childNodes);
      scroll.append(this.guideContent);
      const scope = this.closest('.shopify-section');
      this.priceTarget = this.dialog.querySelector('[data-sg04-price-value]');
      this.priceSource = scope?.querySelector('.product-details product-price[data-product-id]');
      this.syncPrice();
      if (this.priceSource && this.priceTarget) {
        this.priceObserver = new MutationObserver(this.syncPrice);
        this.priceObserver.observe(this.priceSource, { childList: true, characterData: true, subtree: true, attributes: true });
      }
      this.panelNav = document.createElement('nav');
      this.panelNav.className = 'sg04-navigation';
      this.panelNav.setAttribute('aria-label', this.guideTitle);
      this.dialog.querySelector('.sg04-header').after(this.panelNav);
      this.panelLinks = [];
      const addPanelLink = (summary, article = null) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.textContent = summary.dataset.panelTitle || summary.textContent.trim();
        button.addEventListener('click', () => this.openGuide(summary, article), options);
        this.panelLinks.push({ button, article });
        this.panelNav.append(button);
      };
      const bindRow = (summary, article = null) => {
        const details = summary.parentElement;
        summary.dataset.panelTitle = summary.textContent.trim();
        details.classList.add('sg04-dual-row');
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'sg04-panel-open';
        button.textContent = '+';
        button.insertAdjacentHTML('beforeend', '<svg class="sg04-panel-circle" viewBox="0 0 32 32" fill="none" aria-hidden="true"><path d="M25 6C18 0 5 4 3 14C0 25 13 31 23 27C33 22 30 9 23 5C16 1 8 4 5 9" stroke="currentColor" stroke-width="1.1" stroke-linecap="round"/></svg>');
        button.setAttribute('aria-label', this.dataset.panelLabel.replace('[title]', summary.dataset.panelTitle));
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', this.dialog.id);
        const hint = document.createElement('span');
        hint.className = 'sg04-panel-hint';
        hint.append(document.createTextNode(this.dataset.panelHint));
        hint.insertAdjacentHTML('beforeend', '<svg width="30" height="20" viewBox="0 0 30 20" fill="none" aria-hidden="true"><path d="M2 17C8 17 10 5 26 5M21 1L27 5L22 10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>');
        summary.append(hint);
        summary.append(button);
        summary.addEventListener('click', e => {
          e.preventDefault(); e.stopImmediatePropagation();
          if (e.target.closest('.sg04-panel-open, .sg04-panel-hint')) {
            this.openGuide(button, article);
          } else {
            if (!article && !details.open) {
              this.guideContent.classList.add('sg04-inline-guide');
              this.append(this.guideContent);
            }
            details.open = !details.open;
          }
        }, { ...options, capture: true });
      };
      scope?.querySelectorAll('details[data-testid="accordion-details"]').forEach(details => {
        if (details.parentElement.closest('details')) return;
        if (details.contains(this)) { addPanelLink(this.summary); bindRow(this.summary); return; }
        const summary = details.querySelector(':scope > summary');
        const content = details.querySelector(':scope > .details-content');
        if (!summary || !content) return;
        addPanelLink(summary, { details, content });
        bindRow(summary, { details, content });
      });
      this.setupMatFitCTA(scope, options);
      if (this.summary?.parentElement.open) {
        this.guideContent.classList.add('sg04-inline-guide');
        this.append(this.guideContent);
      }
    }
    syncPrice = () => {
      if (!this.priceTarget) return;
      const price = this.priceSource?.querySelector('[data-de-price]')?.textContent?.trim()
        || this.priceSource?.querySelector('[ref="priceContainer"] .price bdi')?.textContent?.trim()
        || this.priceSource?.querySelector('[ref="priceContainer"] .price')?.textContent?.trim()
        || this.priceSource?.querySelector('.price bdi')?.textContent?.trim()
        || this.priceSource?.querySelector('.price')?.textContent?.trim();
      if (price && this.priceTarget.textContent.trim() !== price) this.priceTarget.textContent = price;
    };
    renderTable() {
      const source = this.sets[this.unit] ? this.unit : Object.keys(this.sets)[0];
      const data = this.sets[source]; if (!data?.length) { (this.guideContent || this.dialog).querySelector('.sg04-measures').hidden = true; return; }
      const converted = data.map((row, r) => row.map((value, c) => {
        if (!r || !c || source === this.unit || !/^-?\d+(?:\.\d+)?$/.test(value)) return value;
        return String(Number((Number(value) * (this.unit === 'cm' ? 2.54 : 1 / 2.54)).toFixed(this.decimals)));
      }));
      const table = /^(size|taglia)$/i.test(converted[0][0]) ? converted : converted[0].map((_, c) => converted.map(row => row[c] || '—'));
      const root = this.guideContent || this.dialog;
      const head = root.querySelector('thead'), body = root.querySelector('tbody'); head.replaceChildren(); body.replaceChildren();
      table.forEach((row, r) => { const tr = document.createElement('tr'); row.forEach((value, c) => { const cell = document.createElement(!r || !c ? 'th' : 'td'); if (!r || !c) cell.scope = !r ? 'col' : 'row'; cell.textContent = !r && !c ? this.dataset.sizeLabel : value; tr.append(cell); }); (r ? body : head).append(tr); });
      (this.guideContent || this.dialog).querySelectorAll('[data-unit]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.unit === this.unit)));
    }
    getSelectedSize(scope) {
      const picker = scope?.querySelector('variant-picker');
      if (!picker) return '';

      const checked = [...picker.querySelectorAll('input:checked')].find((input) => {
        const name = String(input.dataset.optionName || input.name || '').toLowerCase();
        return name.includes('size') || name.includes('taglia');
      });
      if (checked) return String(checked.value || checked.getAttribute('aria-label') || '').trim();

      const select = [...picker.querySelectorAll('select')].find((node) => {
        const option = node.options?.[node.selectedIndex];
        const name = String(option?.dataset.optionName || node.name || '').toLowerCase();
        return name.includes('size') || name.includes('taglia');
      });
      return String(select?.value || '').trim();
    }

    getSelectedMeasurements(size) {
      const source = this.sets[this.unit] ? this.unit : Object.keys(this.sets)[0];
      const data = this.sets[source];
      if (!size || !data?.length) return {};

      const converted = data.map((row, r) => row.map((value, c) => {
        if (!r || !c || source === this.unit || !/^-?\d+(?:\.\d+)?$/.test(value)) return value;
        return String(Number((Number(value) * (this.unit === 'cm' ? 2.54 : 1 / 2.54)).toFixed(this.decimals)));
      }));

      const key = String(size).trim().toLowerCase();
      const firstRow = converted[0] || [];
      const column = firstRow.findIndex((value, index) => index > 0 && String(value).trim().toLowerCase() === key);
      const measurements = {};

      if (column > 0) {
        converted.slice(1).forEach((row) => {
          const label = String(row[0] || '').trim();
          const value = String(row[column] || '').trim();
          if (label && value) measurements[label] = value;
        });
        return measurements;
      }

      const row = converted.slice(1).find((candidate) => String(candidate[0] || '').trim().toLowerCase() === key);
      if (row) {
        firstRow.slice(1).forEach((label, index) => {
          const cleanLabel = String(label || '').trim();
          const value = String(row[index + 1] || '').trim();
          if (cleanLabel && value) measurements[cleanLabel] = value;
        });
      }
      return measurements;
    }

    setupMatFitCTA(scope, options) {
      const root = this.guideContent || this.dialog;
      const cta = root.querySelector('[data-mat-fit-start]');
      const sizeLabel = root.querySelector('[data-mat-fit-size]');
      if (!cta) return;

      const sync = () => {
        const size = this.getSelectedSize(scope);
        if (sizeLabel) sizeLabel.textContent = size ? 'Selected size ' + size : 'Select a size';
        cta.disabled = !size;
      };
      sync();
      scope?.addEventListener('change', sync, options);

      cta.addEventListener('click', () => {
        const selectedSize = this.getSelectedSize(scope);
        if (!selectedSize) return;

        const panel = scope?.querySelector('[data-mat-panel]');
        const detail = {
          entryPoint: 'size_chart',
          productId: panel?.dataset.productId || this.dataset.productId || '',
          selectedSize,
          measurementUnit: this.unit,
          measurements: this.getSelectedMeasurements(selectedSize),
        };

        window.dispatchEvent(new CustomEvent('mat:fit-entry', { detail }));

        const tryOn = this.panelLinks?.find((link) => {
          const title = link.article?.details?.querySelector(':scope > summary')?.dataset.panelTitle
            || link.button?.textContent
            || '';
          return String(title).trim().toLowerCase() === 'try on';
        });

        if (tryOn?.article) {
          this.openGuide(cta, tryOn.article);
          return;
        }

        if (this.dialog.open) this.dialog.close();
        requestAnimationFrame(() => scope?.querySelector('[data-mat-open]')?.click());
      }, options);
    }

    openGuide(trigger, article = null) {
      const wasOpen = this.dialog.open;
      if (!wasOpen && this.locked) this.unlock();
      this.restoreArticle();
      this.guideContent.classList.remove('sg04-inline-guide');
      this.dialog.querySelector('.sg04-scroll').append(this.guideContent);
      if (!wasOpen) this.returnFocus = trigger;
      this.panelLinks?.forEach(link => link.button.setAttribute('aria-pressed', String(link.article?.details === article?.details)));
      if (!article) this.dialog.querySelector('h2').textContent = 'Size & Fit';
      if (article) {
        this.article = article;
        this.articleNext = article.content.nextSibling;
        this.guideContent.hidden = true;
        article.content.classList.add('sg04-article');
        this.dialog.querySelector('.sg04-scroll').append(article.content);
        this.dialog.querySelector('h2').textContent = this.panelHeading(article.details.querySelector('summary').dataset.panelTitle);
        this.dialog.querySelector('[data-guide-close]').setAttribute('aria-label', document.documentElement.lang.startsWith('it') ? 'Chiudi pannello' : 'Close panel');
      }
      if (!wasOpen) {
      this.locked = [...new Set([document.documentElement, document.body, document.querySelector('.page-wrapper')].filter(Boolean))].map(el => ({ el, value: el.style.getPropertyValue('overflow'), priority: el.style.getPropertyPriority('overflow') }));
      this.locked.forEach(({el}) => el.style.setProperty('overflow', 'hidden', 'important'));
      this.dialog.showModal();
      }
      this.dialog.querySelector('.sg04-scroll').scrollTop = 0; this.paintMoss();
    }
    restoreArticle() {
      if (this.article) {
        this.article.content.classList.remove('sg04-article');
        this.article.details.insertBefore(this.article.content, this.articleNext);
        this.article = null;
      }
      if (this.guideContent) this.guideContent.hidden = false;
      if (this.guideTitle) this.dialog.querySelector('h2').textContent = this.guideTitle;
      if (this.guideCloseLabel) this.dialog.querySelector('[data-guide-close]').setAttribute('aria-label', this.guideCloseLabel);
    }
    unlock() {
      this.restoreArticle();
      if (this.summary?.parentElement.open && this.guideContent) {
        this.guideContent.classList.add('sg04-inline-guide');
        this.append(this.guideContent);
      }
      this.locked?.forEach(({el, value, priority}) => value ? el.style.setProperty('overflow', value, priority) : el.style.removeProperty('overflow')); this.locked = null;
      if (this.returnFocus?.isConnected) this.returnFocus.focus({ preventScroll: true });
    }
    paintMoss() {
      const engine = window.Moss04Engine, host = this.dialog.querySelector('.sg04-moss');
      if (!this.dialog.open || !engine || !host.clientWidth) return;
      const config = window.__moss04 || {};
      this.moss ||= new engine.Layer(host, { lut: engine.makeLUT(config.palette), size: config.size || 1, dir: 'up', profile: t => engine.ss(0, 1, t) * .8 });
      this.moss.build();
      if (matchMedia('(prefers-reduced-motion: reduce)').matches || this.moss.done) this.moss.paint(.9);
      else this.moss.grow(.9, 1400);
    }
    disconnectedCallback() { this.unlock(); this.controller?.abort(); this.resize?.disconnect(); this.priceObserver?.disconnect(); this.dialog?.remove(); this.dialog = null; }
  }
  customElements.define('size-fit-guide-04', SizeFitGuide);
})();
